import redirects from '../routes/redirects/redirects-url.json';

interface Redirect {
  oldUrl: string;
  newUrl: string;
}

interface RedirectsConfig {
  redirects: Redirect[];
}

/**
 * Checks if the current URL needs to be redirected based on the redirects configuration
 * @returns {boolean} - Returns true if a redirect was performed, false otherwise
 */

export const handleRedirects = (): boolean => {
  const currentUrl = window.location.href;
  const currentOrigin = window.location.origin;

  const redirect = (redirects as RedirectsConfig).redirects.find((redirect) => {
    try {
      const oldUrlObj = new URL(redirect.oldUrl);
      // If oldUrl has a path beyond "/"
      if (oldUrlObj.pathname && oldUrlObj.pathname !== '/') {
        return currentUrl.startsWith(oldUrlObj.origin + oldUrlObj.pathname);
      }
      // just match origin
      return currentOrigin === oldUrlObj.origin;
    } catch {
      return false;
    }
  });

  if (redirect) {
    window.location.href = redirect.newUrl;
    return true;
  }

  return false;
};
